import { SignIn } from '@clerk/clerk-react'

export function SignInPage() {
  return (
    <main className="h-screen w-screen flex items-center justify-center p-4 bg-gray-950 text-white">
      <section className="w-full max-w-md rounded-xl border border-white/10 bg-slate-900 p-6 shadow-xl">
        <div className="mb-4 text-center">
        <h1 className="text-xl font-semibold">Welcome to Step Chat</h1>
        <p className="mt-2 text-sm text-gray-300">
          Sign in to continue to the app.
        </p>
        </div>
        <SignIn />
      </section>
    </main>
  )
}
